const style = {
  toggleAllSwitch: {
    display: "block",
    marginTop: "10px",
    marginBottom: "5px"
  }
};

export default style;



// WEBPACK FOOTER //
// ./src/components/PermissionsToggles/FacilityPermissions/style.js